export default __webpack_public_path__ + "static/media/error.2ab7d835.svg";